import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function PowerOfAttorneyPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['power-of-attorney']} />;
}
